import React from "react";
import { toast } from "react-toastify";
import CustomToast from "../components/shared/CustomToast";

const bgColors = {
  success: "#0ab159", 
  error: "#fc4449",  
  info: "#3c82f6",   
};

const textColors = {
  success: "#fff",
  error: "#fff",   
  info: "#fff",    
};
export const showErrorToast = (message) => {
   toast(<CustomToast type="error" message={message} />, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    closeButton: false,
    style: {
      background: bgColors['error'],
      color: textColors['error'],
      padding: "16px",
      borderRadius: "14px"
    },
  });
};

export const showSuccessToast = (message) => {
   toast(<CustomToast type="success" message={message} />, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    closeButton: false,
    style: {
      background: bgColors['success'],
      color: textColors['success'],
      padding: "16px",
      borderRadius: "14px"
    },
  });
};
